namespace Nobox {
    export interface ChatroomagentsRow {
        Id?: number;
        RoomId?: number;
        UserId?: number;
        HandId?: number;
        St?: number;
        CtId?: number;
        CtRealId?: number;
        ChId?: number;
        ChAccId?: number;
        UserEmail?: string;
        UserImage?: string;
        DisplayName?: string;
        LastLogin?: string;
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
        HanderNm?: string;
        Ct?: string;
        LastMsg?: string;
        CtReal?: string;
        IdExt?: string;
        Ch?: string;
        Handler?: string;
    }

    export namespace ChatroomagentsRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Chat.Chatroomagents';
        export const lookupKey = 'Chat.Chatroomagents';

        export function getLookup(): Q.Lookup<ChatroomagentsRow> {
            return Q.getLookup<ChatroomagentsRow>('Chat.Chatroomagents');
        }
        export const deletePermission = 'ChatRoom:Delete';
        export const insertPermission = 'ChatRoom:Modify';
        export const readPermission = 'ChatRoom:View';
        export const updatePermission = 'ChatRoom:Modify';

        export declare const enum Fields {
            Id = "Id",
            RoomId = "RoomId",
            UserId = "UserId",
            HandId = "HandId",
            St = "St",
            CtId = "CtId",
            CtRealId = "CtRealId",
            ChId = "ChId",
            ChAccId = "ChAccId",
            UserEmail = "UserEmail",
            UserImage = "UserImage",
            DisplayName = "DisplayName",
            LastLogin = "LastLogin",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy",
            HanderNm = "HanderNm",
            Ct = "Ct",
            LastMsg = "LastMsg",
            CtReal = "CtReal",
            IdExt = "IdExt",
            Ch = "Ch",
            Handler = "Handler"
        }
    }
}
